import { jsx as _jsx } from "react/jsx-runtime";
import Loading from '@web/components/layout/Loading';
import { OnboardingPage } from '@web/components/Onboarding/OnboardingPage';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { trpc } from '@web/lib/trpc';
import { useState } from 'react';
export function OnboardingView() {
    var _a;
    var _b = trpc.currentUser.useQuery(), currentUser = _b.data, refetch = _b.refetch, isFetching = _b.isFetching;
    var userCtxRefetch = useWorkspaceCtx().userCtxRefetch;
    var _c = useState(false), isReady = _c[0], setIsReady = _c[1];
    if (currentUser && !isReady && !isFetching) {
        if (!((_a = currentUser.workspace) === null || _a === void 0 ? void 0 : _a.isProcessingSync)) {
            setIsReady(true);
        }
        else {
            setTimeout(function () {
                refetch();
                userCtxRefetch();
            }, 1000);
        }
    }
    if (!currentUser || !isReady) {
        return _jsx(Loading, {});
    }
    return _jsx(OnboardingPage, {});
}
